// extracted by mini-css-extract-plugin
module.exports = {"Container":"NotFound_Container__2RUaK","Content":"NotFound_Content__fb7eL","icon":"NotFound_icon__3Pro9"};